import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const computedStyle = window.getComputedStyle(this.element);
    const position = computedStyle.position;

    // Ensure the element has position relative/absolute for overlay
    if (position === 'static') {
      this.element.style.position = 'relative';
    }

    // Create overlay div
    this.overlay = document.createElement('div');
    this.overlay.style.cssText = `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(255, 193, 7, 0.95);
      color: #856404;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 1.2rem;
      gap: 0.5rem;
      z-index: 1000;
      border: 2px solid #ffc107;
      border-radius: 0.25rem;
      pointer-events: none;
      padding: 0.75rem 1.5rem;
    `;

    this.overlay.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
      </svg>
      <span>Replace me</span>
    `;

    this.element.appendChild(this.overlay);
  }

  disconnect() {
    if (this.overlay && this.overlay.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay);
    }
  }
}
